import React, { useEffect, useState } from "react";
import { useAppContext } from "../context/AppContext";
import { composeSamplePRomptsConfig, samplePromptsConfig } from "../utils/settings";

const SamplePrompts = () => {
  const { setSelectedAction, setPrompt, mode } = useAppContext();
  const [samplePrompts, setSamplePrompts] = useState(samplePromptsConfig);

  useEffect(() => {
    if (mode === "compose") {
      setSamplePrompts(composeSamplePRomptsConfig);
    }
  }, [mode]);

  const handleSamplePromptClick = (prompt) => {
    setSelectedAction(prompt.action);
    setPrompt(prompt.title);
  };

  return (
    <div className="sample-prompts">
      {samplePrompts.map((prompt, index) => (
        <button
          key={index}
          className="sample-prompt-card"
          onClick={() => handleSamplePromptClick(prompt)}
        >
          <div className="sample-prompt-card-body">
            <div className="icon-wrapper">
              <img src={prompt.icon} alt={prompt.title} className="sample-prompt-icon" />
              <div className="sample-prompt-title">{prompt.title}</div>
            </div>
            <div className="sample-prompt-content">
              <div className="sample-prompt-subtitle">{prompt.desc}</div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default SamplePrompts;
